export default {"src":"/_next/static/media/arrow-white.ce6fb50c.svg","height":6,"width":38,"blurWidth":0,"blurHeight":0};